export default __webpack_public_path__ + "static/media/logo-full.7101bb87.svg";